/*
* @Author: Johnny.liu
* @Date:   2021-05-17 10:50:35
* @Last Modified by:   Johnny.liu
* @Last Modified time: 2021-05-17 14:21:34
*/
import { param } from "jquery";
import { HTTP } from "../../lib/http"
import url from "../../lib/url";

export const APIService = {

    http: HTTP,

    async getUrlData(url, param) {
        return await this.http.postImmediately({
            type: 'post',
            url: url,
            data: param
        });
    },

    /**
     * [ProductDasicData 产品基础信息]
     */
    async ProductDasicData(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/product_basic_data/',
            data: param
        });
    },

     /**
     * [getDxjgProjInfo 获取代销机构详情数据
     */
      async getDxjgProjInfo(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_dxjg_proj_info/',
            data: param
        });
    },


    /**
    * [SaveDxjgProjInfo 保存编辑代销机构详情数据]
    */
    async SaveDxjgProjInfo(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/save_dxjg_proj_info/',
            data: param
        });
    },

    /**
    * [getDxjgChangeRecords 获取代销机构变动记录列表数据]
    */
      async getDxjgChangeRecords(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_dxjg_change_records/',
            data: param
        });
    },

    /**
    * [getDxjgChangeInfo 获取代销机构变动记录详情]
    */
       async getDxjgChangeInfo(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_dxjg_change_info/',
            data: param
        });
    },
    /**
    * [getDxjgChangeInfo 批量报送展示接口]
    */
       async getBatchSubmissionList(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/batch_submission_list/',
            data: param
        });
    },
    /**
    * [getDxjgChangeInfo 批量报送发起流程接口]
    */
      async postBatchSponsorDxFlow(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/batch_sponsor_dx_flow/',
            data: param
        });
    },
    
    /**
    * [getDxjgInteractiveRecord 代销机构交互记录列表数据]
    */
     async getDxjgInteractiveRecord(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_dxjg_interactive_record/',
            data: param
        });
    },
    
    /**
    * [getDxjgInteractiveInfo 获取代销机构交互记录详情]
    */
     async getDxjgInteractiveInfo(param) {
        return await this.http.postImmediately({
            type: 'post',
            url: '/citic/get_dxjg_interactive_info/',
            data: param
        });
    },

    /**
	 * [getUserListSameDept 获取人员列表]
	 * @param {[type]} param [description]
	 */
	async getUserListSameDept () {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_user_list_same_dept/',
		});
	},
    
    /**
	 * [saveDxjgProjDraftInfo 保存草稿]
	 * @param {[type]} param [description]
	 */
	async saveDxjgProjDraftInfo (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/save_dxjg_proj_draft_info/',
            data: param
		});
	},

    /**
	 * [getXpReportInfo 信披报告审批查看详情]
	 * @param {[type]} param [description]
	 */
	async getXpReportInfo (param) {
		return await this.http.postImmediately({
			type: 'post',
			url: '/citic/get_xp_report_info/',
            data: param
		});
	},

}


// WEBPACK FOOTER //
// app/services/commission/api.js